import { setSubscriptionStatus } from '../../utils/utils';

const INITIAL_STATE = {
  podcastUser: null,
  braintreeToken: null,
  subscription: null,
  subscriptions: null,
  mysubscriptions: {},
  firebaseInfo: null,
  freeTrial: null,
  fetching: false,
  fetched: false,
  error: null,
  result: null,
  isAdmin: false,
  plans: null,
  consumedLink: null,
  showOnBoardingMsg: null,
  categoryTypesByUser: [],
  isFirstLogin: false
};

export default function reducer(state = INITIAL_STATE, action) {
  if (action.type === 'FETCH_PODCAST_USER' && action.error) {
    return { ...state, error: 'There is a problem. Please try again later!' };
  }

  switch (action.type) {
    case 'UPDATE_IS_FIRST_LOGIN': {
      return {
        ...state,
        isFirstLogin: action.payload
      };
    }
    case 'FETCH_PODCAST_USER': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        podcastUser: action.payload.data
      };
    }
    case 'FETCH_BRAINTREE_TOKEN': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        braintreeToken: action.payload.data
      };
    }
    case 'ACTIVATE_PAYPAL_USER': {
      const newUser = {
        ...state.podcastUser,
        active: true,
        paypal_subscription_info: action.payload
      };
      return { ...state, fetching: false, fetched: true, podcastUser: newUser };
    }
    case 'CANCEL_SUBSCRIPTION': {
      const newUser = { ...state.podcastUser, active: false };
      return { ...state, fetching: false, fetched: true, podcastUser: newUser };
    }
    case 'EDIT_SUBSCRIPTION': {
      return { ...state, fetching: false, fetched: true };
    }
    case 'FETCH_SUBSCRIPTION': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        subscription: action.payload.data
      };
    }
    case 'SET_FIREBASE_INFO': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        firebaseInfo: action.payload
      };
    }
    case 'START_FREE_TRIAL': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        freeTrial: action.payload
      };
    }
    case 'SIGN_OUT': {
      return INITIAL_STATE;
    }
    case 'IS_ADMIN': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        isAdmin: action.payload.data
      };
    }
    case 'FETCH_PLANS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        plans: action.payload.data
      };
    }
    case 'FETCH_SUBSCRIPTIONS': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        subscriptions: action.payload.data
      };
    }
    case 'FETCH_MY_SUBSCRIPTIONS': {
      const data = action.payload.data;

      // Transform data: Array of subscriptions to object of specified subscription type arrays
      const mysubscriptions =
        data !== undefined && data.length
          ? data.reduce((mysubscriptions, item) => {
              if (mysubscriptions[item.type] === undefined) {
                mysubscriptions[item.type] = [];
              }

              mysubscriptions[item.type].push({
                ...item,
                status: setSubscriptionStatus(item)
              });

              return mysubscriptions;
            }, {})
          : {};

      return { ...state, fetching: false, fetched: true, mysubscriptions };
    }
    case 'CHECK_INVITATION_LINK': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        consumedLink: action.payload.data
      };
    }
    case 'SHOW_MSG': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        showOnBoardingMsg: action.payload.data
      };
    }
    case 'CATEGORY_TYPES_BY_USER': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        categoryTypesByUser: action.payload.data
      };
    }
    case 'UPDATE_USER_DATA': {
      return {
        ...state,
        podcastUser: action.payload
      };
    }
    default:
      return state;
  }
}
